import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.orderLines.title',
    defaultMessage: 'Order lines',
    description: 'title of the order lines page',
  },
  actions: {
    createOrder: {
      id: 'pages.orderLines.actions.createOrder',
      defaultMessage: 'Place on order',
      description: 'Label of the place on order action',
    },
  },
  feedback: {
    orderNotCreated: {
      id: 'pages.orderLines.feedback.orderNotCreated',
      defaultMessage: 'Order could not be created',
      description: 'Order created error message',
    },
  },
};

export default defineMessages(translations);
